import styled from 'styled-components';
import { styleguide } from '../../../../theme/styleguide';

export const DivButton = styled.div`
  width: 90%;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  padding: 24px;

  > button {
    width: 100%;
  }
`;

export const DivDeviceInfo = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 16px;
  color: #000000;
  > span {
    width: 100%;
    height: 16px;
  }
  > p {
    font-size: 14px;
    font-weight: 700;
    margin: 4px 0px 0px 0px;
  }
`;

export const SessionContent = styled.div`
  width: 406px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  box-shadow: 0px 1px 2px 0px #00000033;
  @media (max-width: 650px) {
    width: 100%;
    margin: 0 auto;
  }
`;

export const ListSessions = styled.ul`
  width: 100%;
  border-radius: 3px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SessionItemList = styled.li`
  hr {
    margin: 0 auto;
    height: 1px;
    background-color: #e6e6e6;
    border: none;
    width: 88%;
  }

  .button {
    border: none;
    background: none;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px;
    > div:first-child {
      display: flex;
      padding: 24px 0 16px 0;
    }
    @media (max-width: 650px) {
      padding: 0 16px 0 16px;
    }
  }
`;

export const RemoveSessionMessage = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 24px 24px 16px 24px;
  gap: 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 25.2px;
  color: #000000;

  @media (max-width: 650px) {
    padding: 16px;
  }

  > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    > p {
      width: 70%;
      margin: 0;
    }
  }

  hr {
    width: 100%;
    height: 1px;
    margin: 0 auto;
    background-color: #d8d8d8;
    border: none;
  }
`;

type Props = {
  maxWidth?: string;
  contentWidth?: string;
  contentHeight?: string;
  borderRadius?: string;
  paddingTop?: string;
  padding?: string;
};

export const ModalContainer = styled.div<Props>`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: ${({ paddingTop }) => paddingTop || '100px'};
  background-color: rgba(0, 0, 0, 0.4);
`;

export const ModalContent = styled.div<Props>`
  background-color: #fefefe;
  position: relative;
  margin: auto;
  padding: ${({ padding }) => padding || '24px'};
  gap: 16px;
  border: 1px solid #888;
  width: 312px;
  height: 358px;
  border-radius: ${({ borderRadius }) => borderRadius || '5px'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    width: 496px;
    height: 318px;
    padding: 32px;
  }
`;

export const ModalHeader = styled.div`
  font-size: 28px;
  line-height: 24px;
  letter-spacing: -0.25px;
  display: flex;
  justify-content: space-between;
  width: 264px;
  height: 62px;
  gap: 16px;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    width: 432px;
    height: 78px;
  }

  button {
    cursor: pointer;
    border: 0;
    background-color: #ffffff;
  }
`;

export const ModalHeaderCustom = styled.div`
  width: 264px;
  height: 62px;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.25px;
  display: flex;
  justify-content: space-between;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    width: 432px;
    height: 78px;
  }

  button {
    cursor: pointer;
    border: 0;
    background-color: #ffffff;
  }
`;

export const TextHeaderCustom = styled.div`
  font-size: 24px;
  letter-spacing: -0.25px;
  display: flex;
  font-family: 'Inter';
  justify-content: space-between;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    font-size: 28px;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  font-size: 16px;
  line-height: 20px;
  width: 264px;
  height: 96px;
  padding: 0;
  color: #333333;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    width: 432px;
    margin-top: 0;
    font-size: 18px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  width: 264px;
  height: 98px;
  align-items: center;
  margin-top: auto;

  > button {
    width: 100%;
    height: 40px;
  }

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    flex-direction: row;
    width: 432px;
    height: 48px;
  }
`;

export const ModalButtonClose = styled.button`
  display: flex;
  justify-content: start;
  margin: 0;
  padding: 0;
`;

export const TextHeaderModal = styled.h2`
  font-family: 'Inter';
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0px;
  font-weight: 600;
  width: 100%;
  margin: 0;
  color: #000000;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    font-size: 28px;
  }
`;
